const bannerPic = document.querySelector('.js-banner__pic');

if (bannerPic) {
	let scrollPos;
	const bannerPicHeight = bannerPic.offsetHeight;

	window.addEventListener(
		'scroll',
		() => {
			if (scrollPos && scrollPos > window.scrollY) {
				scrollPos = 'top';
			} else {
				scrollPos = 'bottom';
			}

			if (bannerPicHeight > window.scrollY) {
				window.requestAnimationFrame(() => {
					const position = (window.scrollY * (scrollPos === 'bottom' ? 0.4 : -0.4)) / 10;

					bannerPic.style.transform = `translateY(${position}vh)`;
				});
			}
		},
		{ passive: true },
	);
}
